function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import { useCombobox } from "downshift";
import moment from "moment";
import isEmpty from "lodash-es/isEmpty";
import Input from "../../forms/input/Input";
import { TIME_FORMAT } from "./constants";
import { onEnter } from "../../helpers";
import { inferTime, toMinutes } from "./parseDate";
import { getHoursAndMinutes } from "./utils";
function format(num) {
  const day = moment();
  day.set(getHoursAndMinutes(num));
  return day.format(TIME_FORMAT);
}
const options = [];
const formats = [];
const MINUTES_IN_DAY = 60 * 24;
for (let i = 0; i < MINUTES_IN_DAY; i += 30) {
  options.push(i);
  formats[i] = format(i);
}
function closestIndex(num) {
  let [prev] = options;
  for (let i = 1; i < options.length; i++) {
    const curr = options[i];
    if (Math.abs(num - curr) > Math.abs(num - prev)) {
      return i - 1;
    }
    prev = curr;
  }
  return options.length - 1;
}
function formatValue(value) {
  if (typeof value === "number" && formats[value]) {
    return formats[value];
  }
  if (typeof value === "string" && isEmpty(value)) {
    return value;
  }
  return format(value);
}
export function TimeSelect(props) {
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef();
  const optionsRef = useRef();
  useEffect(() => {
    setInputValue(formatValue(props.value));
  }, [props.value]);
  const {
    isOpen,
    getLabelProps,
    getMenuProps,
    getItemProps,
    getInputProps,
    getComboboxProps,
    openMenu,
    setHighlightedIndex
  } = useCombobox({
    items: options,
    selectedItem: props.value,
    onSelectedItemChange(_ref) {
      let {
        selectedItem
      } = _ref;
      props.onChange(selectedItem);
    },
    itemToString: formatValue
  });
  useLayoutEffect(function scrollOptionIntoView() {
    const minutes = toMinutes(inferTime(inputValue, props.date));
    const index = options.findIndex(option => minutes === option);
    if (index !== -1) setHighlightedIndex(index);else if (isOpen) {
      const closest = closestIndex(minutes);
      requestAnimationFrame(() => {
        const option = optionsRef.current.querySelector(`li:nth-child(${closest + 1})`);
        if (option) {
          option.scrollIntoView({
            block: "center"
          });
        }
      });
    }
  }, [inputValue, isOpen]);
  const {
    onKeyDown,
    ...inputProps
  } = getInputProps({
    ref: inputRef,
    onFocus(e) {
      if (!isOpen) openMenu();
      const input = e.currentTarget.querySelector("input");
      input.setSelectionRange(0, input.value.length);
    },
    onBlur() {
      if (isEmpty(inputValue)) {
        props.onChange(inputValue);
        return;
      }
      const value = toMinutes(inferTime(inputValue, props.date));
      if (value === props.value) setInputValue(formatValue(props.value));else props.onChange(value);
    },
    onChange(e) {
      setInputValue(e.currentTarget.value);
    },
    onKeyDown: onEnter(() => {
      const value = toMinutes(inferTime(inputValue, props.date));
      if (value === props.value) setInputValue(formatValue(props.value));else props.onChange(value);
    })
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "tui-date-picker__time-select"
  }, /*#__PURE__*/React.createElement("label", _extends({}, getLabelProps(), {
    style: {
      display: "none"
    }
  }), "Time"), /*#__PURE__*/React.createElement("div", getComboboxProps(), /*#__PURE__*/React.createElement(Input, _extends({
    disabled: props.disabled
  }, inputProps, {
    inputProps: {
      autoComplete: "off",
      onKeyDown
    },
    value: inputValue
  }))), /*#__PURE__*/React.createElement("ul", _extends({
    className: "tui-date-picker__time-select__options",
    style: {
      display: isOpen ? undefined : "none"
    }
  }, getMenuProps({
    ref: optionsRef
  }), {
    tabIndex: -1
  }), isOpen && options.map((item, index) => {
    const disabled = props.minTime && Number(props === null || props === void 0 ? void 0 : props.minTime) > Number(item);
    return /*#__PURE__*/React.createElement("li", _extends({
      key: `${item}${index}`
    }, getItemProps({
      item,
      index,
      disabled,
      className: disabled ? "disabled" : ""
    })), formats[item]);
  })));
}
//# sourceMappingURL=TimeSelect.js.map